import {
  GET_BOOKINGS_BY_RESERVATIONS_REQUEST,
  GET_BOOKINGS_BY_RESERVATIONS_SUCCESS,
  GET_BOOKINGS_BY_RESERVATIONS_FAILURE,
  SET_LOCATION_NAME,
  GetBookingsByReservationIdActionTypes,
  GetBookingsByReservationsState
} from "store/reducers/lodgingRequest/get-bookings-by-reservations/types";

const defaultState: GetBookingsByReservationsState = {
  isLoading: false,
  errorMessage: '',
  name: '',
};

export default function getBookingsByReservationId(state = defaultState, action: GetBookingsByReservationIdActionTypes): GetBookingsByReservationsState {
  switch (action.type) {
    case GET_BOOKINGS_BY_RESERVATIONS_REQUEST:
      return {
        ...state,
        isLoading: true,
        name: state.name,
      };
    case GET_BOOKINGS_BY_RESERVATIONS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_BOOKINGS_BY_RESERVATIONS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case SET_LOCATION_NAME:
      return {
        ...state,
        name: action.name,
      };
    default:
      return state;
  }
};